import React from 'react';

export const EmptyMessage = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="55"
    viewBox="0 0 60 55"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M48.4187 23.9541H29.5299V27.6741H47.7891V50.4808L43.7846 47.0259L43.7547 47.0011C43.1874 46.5315 42.47 46.2741 41.7289 46.2741H21.3447V38.1601H17.5669V46.8941C17.5669 47.7163 17.8986 48.5048 18.489 49.0861C19.0794 49.6675 19.8801 49.9941 20.715 49.9941H41.4928L46.363 54.1977L46.3929 54.2225C46.9569 54.6931 47.6716 54.9522 48.4109 54.9541C48.8728 54.953 49.3289 54.8525 49.7472 54.6596C50.2922 54.4136 50.7537 54.0181 51.0764 53.5206C51.3991 53.023 51.5694 52.4445 51.5669 51.8541V27.0541C51.5669 26.2319 51.2352 25.4434 50.6448 24.8621C50.0544 24.2807 49.2537 23.9541 48.4187 23.9541Z"
      fill="#3655C5"
    />
    <path
      d="M17.5669 27.0541C17.5669 26.2319 17.8986 25.4434 18.489 24.8621C19.0794 24.2807 19.8801 23.9541 20.715 23.9541H29.5299V27.6741H21.3447V38.1601H17.5669V27.0541Z"
      fill="#3655C5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.71507 6.9541H22.6039V10.7941H4.3447V34.3365L8.34914 30.7701L8.37905 30.7445C8.94637 30.2598 9.66376 29.9941 10.4049 29.9941H30.7891V21.6184H34.5669V30.6341C34.5669 31.4828 34.2352 32.2967 33.6448 32.8968C33.0544 33.497 32.2537 33.8341 31.4187 33.8341H10.641L5.77081 38.1733L5.7409 38.1989C5.17692 38.6847 4.46216 38.9522 3.72294 38.9541C3.26101 38.9529 2.8049 38.8492 2.38655 38.6501C1.84156 38.3961 1.3801 37.9879 1.0574 37.4743C0.734691 36.9607 0.564407 36.3635 0.566922 35.7541V10.1541C0.566922 9.30541 0.898601 8.49148 1.48899 7.89136C2.07938 7.29124 2.88013 6.9541 3.71507 6.9541Z"
      fill="#3655C5"
    />
    <path
      d="M34.5669 10.1541C34.5669 9.30541 34.2352 8.49148 33.6448 7.89136C33.0544 7.29124 32.2537 6.9541 31.4187 6.9541H22.6039V10.7941H30.7891V21.6184H34.5669V10.1541Z"
      fill="#3655C5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M59.4331 12.4277C56.2931 10.9043 53.7573 8.36843 52.2339 5.22852C50.7104 8.36843 48.1746 10.9043 45.0347 12.4277C48.1746 13.9512 50.7104 16.487 52.2339 19.6269C53.7573 16.487 56.2931 13.9512 59.4331 12.4277Z"
      fill="url(#paint0_linear_1960_30088)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.8829 0.0449219C42.9688 1.92887 41.4473 3.45037 39.5634 4.36444C41.4473 5.2785 42.9688 6.80001 43.8829 8.68396C44.7969 6.80001 46.3184 5.2785 48.2024 4.36444C46.3184 3.45038 44.7969 1.92887 43.8829 0.0449219Z"
      fill="url(#paint1_linear_1960_30088)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.723 14.4443C40.9613 16.0143 39.6934 17.2822 38.1234 18.0439C39.6934 18.8057 40.9613 20.0736 41.723 21.6435C42.4847 20.0736 43.7527 18.8057 45.3226 18.0439C43.7527 17.2822 42.4847 16.0143 41.723 14.4443Z"
      fill="url(#paint2_linear_1960_30088)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1960_30088"
        x1="45.3285"
        y1="5.22852"
        x2="58.5877"
        y2="5.22852"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F54BEA" />
        <stop offset="1" stop-color="#F9975E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1960_30088"
        x1="39.7397"
        y1="0.0449219"
        x2="47.6952"
        y2="0.0449219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F54BEA" />
        <stop offset="1" stop-color="#F9975E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1960_30088"
        x1="38.2703"
        y1="14.4443"
        x2="44.8999"
        y2="14.4443"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F54BEA" />
        <stop offset="1" stop-color="#F9975E" />
      </linearGradient>
    </defs>
  </svg>
);
